export enum enumApplicationMode {
  USER = 1,
  SUPPORT = 2,
}
